import * as i18n from "../../../util/i18n";

export const formatLoginStep2FirstName = (userFirstName = "") => {
    const firstName = userFirstName;

    return firstName && firstName.length > 1
        ? firstName
              .toLowerCase()
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
              .join(" ")
        : "";
};

export const getLoginStep2WelcomeText = (userFirstName, showSecuritySealTitle) => {
    const formattedFirstName = formatLoginStep2FirstName(userFirstName);

    if (showSecuritySealTitle && formattedFirstName) {
        return i18n.get("login.step1.welcomeWithUser", `Hola, ${formattedFirstName}`, {
            USER_NAME: formattedFirstName,
        });
    }

    return i18n.get("login.step2.header", null, { USER_NAME: formattedFirstName });
};
